<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('projects.editAssistance')"></page-title>
    </div>

    <jet-form-section @submitted="updateState()">

        <template #form>
            <!-- Card Project Assistance -->
            <form-card :title="$t('projects.persons')" :description="$t('projects.personsDescription')">

                <RadioGroup v-model="form.updateResponsible.responsible" class="col-span-6">
                    <RadioGroupLabel class="sr-only">
                        Project Assistance
                    </RadioGroupLabel>
                    <div class="bg-white rounded-md -space-y-px">
                        <RadioGroupOption as="template" v-for="(member, memberIdx) in members" :key="member.id" :value="member" v-slot="{ checked, active }">
                            <div :class="[memberIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '', memberIdx === members.length - 1 ? 'rounded-bl-md rounded-br-md' : '', checked ? 'bg-lime-100 border-lime-200 z-10' : 'border-gray-200', 'relative border p-4 flex cursor-pointer focus:outline-none']">
                                <span :class="[checked ? 'bg-lime-600 border-transparent' : 'bg-white border-gray-300', active ? 'ring-2 ring-offset-2 ring-lime-500' : '', 'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center']" aria-hidden="true">
                                    <span class="rounded-full bg-white w-1.5 h-1.5" />
                                </span>
                                <div class="ml-3 flex flex-col">
                                    <RadioGroupLabel as="span" :class="[checked ? 'text-lime-900' : 'text-gray-900', 'block text-sm font-medium']">
                                        {{ member.name }}
                                    </RadioGroupLabel>
                                    <RadioGroupDescription as="span" :class="[checked ? 'text-lime-700' : 'text-gray-500', 'block text-sm']">
                                        {{ $t("projects.userId") }} {{ member.id }}
                                    </RadioGroupDescription>
                                </div>
                            </div>
                        </RadioGroupOption>
                    </div>
                </RadioGroup>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t('actions.cancel') }}</button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";


export default defineComponent({
    props: ["project", "members", "current"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RadioGroup,
        RadioGroupOption,
        RadioGroupDescription,
        RadioGroupLabel
    },
    data() {
        return {
            form: useForm({
                updateResponsible: {
                    responsible: this.members.find(m => m.id === this.current.id)
                }
            })
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateState() {
            this.form.updateResponsible.responsible = this.form.updateResponsible.responsible.id;
            this.form.post(this.route("advisors.projects.update", { project: this.project.uuid }), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'projects.updated'
                })
            });
        }
    }
});
</script>

<style scoped></style>
